var exports = {
  "kL": "xf61da738--bb99d8--container",
  "wx": "xf61da738--bb99d8--header",
  "Sl": "xf61da738--bb99d8--image",
  "Qs": "xf61da738--bb99d8--content",
  "Qq": "xf61da738--bb99d8--text",
};

module.exports = exports;
